<template slot-scope="scope">
<!-- 会员信息表格组件 -->
  <div class="device-list">
    <div class="device-list-tab">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        @row-click="handelClickName"
        :header-cell-style="{
          background: '#409eff ',
          textAlign: 'center',
          color: '#ffffff',
          padding: '3px',
          fontSize: '12px',
          fontWeight: '400',
          height: '45px',
        }"
        :row-style="{ height: '35px' }"
      >
      <el-table-column label="会员ID" align="center" >
          <template slot-scope="scope">
            <span>{{ scope.row.beInvitedUserCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="会员姓名" align="center" >
          <template slot-scope="scope">
            <span>{{ scope.row.beInvitedUserName }}</span>
          </template>
        </el-table-column>
         
        <el-table-column label="会员类型" align="center" >
          <template slot-scope="scope">
            <span>{{ scope.row.typeName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="邀请时间" align="center" >
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // deviceList: {
    //   type: Array,
    //   default: () => {
    //     return [];
    //   },
    // },
    tableData: {},
    select: {},
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {
    console.log(this.listarr);
  },
  methods: {
    // 点击某一条 将该条信息传给父组件
    handelClickName(val) {
      this.$emit("handelClickName", val);
    },
    //表格颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "warning-row";
      } else if (rowIndex % 2 == 1) {
        return "success-row";
      }
      return "success-row";
    },
  },
};
</script>

<style scoped lang="less">

/deep/th:nth-child(1) {
  border-radius: 10px 0 0 0 !important;
}
/deep/th:nth-child(4) {
  border-radius: 0px 10px 0px 0px !important;
}
// /deep/th:nth-child(4) {
//   border-radius: 0px 10px 0px 0px !important;
// }
// /deep/th:nth-last-child(1) {
//   border-radius: 0 10px 0 0 !important;
// }

/deep/th {
  height: 45px !important;
  padding: 0;
}
/deep/ td {
  height: 40px !important;
  padding: 0;
}
.device-list-tab {
  border: 1px solid #eeeeee;
  border-radius: 10px 10px 0 0;
}
/deep/.el-table__empty-block,
/deep/.el-table tr,
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  color: #333333;
  font-weight: 400;
  font-size: 12px;
}
/deep/.el-table .warning-row td {
  font-size: 12px;
  color: #333333;
}

/deep/.el-table__body tr {
  cursor: pointer;
}

::v-deep .el-table .warning-row td {
  background: #eeeeee !important;
}
/deep/.device-list {
  border: 1px solid goldenrod !important;
}
</style>
